export default class Contact {

    constructor() {
        if (document.querySelector('#show.contact') !== null) {
            this.map();
        }

        this.handleForm();
    }

    map() {
        if (document.querySelector('#mapDordrecht')
            && document.querySelector('#mapZwijndrecht')
            && document.querySelector('#mapPapendrecht')) {
            const mapDordrechtHolder = document.querySelector('#mapDordrecht');
            const mapZwijndrechtHolder = document.querySelector('#mapZwijndrecht');
            const mapPapendrechtHolder = document.querySelector('#mapPapendrecht');

            const mapHolders = [
                mapDordrechtHolder,
                mapZwijndrechtHolder,
                mapPapendrechtHolder
            ];

            const coordinates = {
                mapDordrecht: {lat: 51.8093743, lng: 4.6684119},
                mapZwijndrecht: {lat: 51.8221215, lng: 4.6455639},
                mapPapendrecht: {lat: 51.828505, lng: 4.6830076}
            };

            mapHolders.forEach((item) => {
                const lat = coordinates[item.id]['lat'];
                const lng = coordinates[item.id]['lng'];

                console.log(lat, lng);

                const map = new google.maps.Map(item, {
                    disableDefaultUI: true,
                    center: {lat: lat, lng: lng},
                    zoom: 14
                });

                const icon = new google.maps.MarkerImage(
                    '/img/map-marker.svg',
                    null, /* size is determined at runtime */
                    null, /* origin is 0,0 */
                    null, /* anchor is bottom center of the scaled image */
                    new google.maps.Size(50, 50)
                );

                new google.maps.Marker({
                    position: new google.maps.LatLng(lat, lng),
                    map: map,
                    icon: icon
                });
            });
        }
    }

    handleForm() {
        if (document.querySelector('.form-style')) {
            const formGroups = document.querySelectorAll('.form-style .form-group:not(.select)');

            formGroups.forEach((item) => {
                const input = item.querySelector('input, textarea');

                const handleFocus = () => {
                    item.classList.add('focus');
                }

                const handleBlur = () => {
                    if (input.value.length === 0) {
                        item.classList.remove('focus');
                    }
                }

                const handleInput = () => {
                    if (input.value.length === 0 && document.activeElement === input) {
                        item.classList.add('focus');
                    } else if (input.value.length > 0) {
                        item.classList.add('focus');
                    } else {
                        item.classList.remove('focus');
                    }
                }

                input.addEventListener('focus', handleFocus);
                input.addEventListener('blur', handleBlur);
                input.addEventListener('input', handleInput);

                if (input.value.length > 0) {
                    item.classList.add('focus');
                }
            });
        }
    }
}
